import { CustomTextField, SingleFormBoxScene, SingleTableBoxScene } from "@/shared/components/ui";
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from "react-router-dom";
import { gridSizeMdLg12, ROUTER_PATHS } from "@/shared";
import { toast } from "react-toastify";
import { useCreateActivityType } from "../../actions/noc-module.actions";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ActivityType } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";
import * as yup from 'yup';

type SaveFormData = Omit<ActivityType, 'idActivityType'>;

export default function ParametrosTipoActividadCrearPage() {

    const navigate = useNavigate();
    const returnUrlOrdenTrabajoParametrosPage = ROUTER_PATHS.noc.ordenesDeTrabajoNocParametrosNav;

    const useCreateActivityTypeMutation = useCreateActivityType();

    const newActivityTypeSchema = yup.object({
        nameActivityType: yup.string().required('Nombre de la actividad requerido'),
    });

    const form = useForm<SaveFormData>({
        resolver: yupResolver(newActivityTypeSchema as any),
        defaultValues: {
            nameActivityType: '',
            statusActivityType: true
        },
    });

    const {
        control,
        handleSubmit,
        formState: { errors, isValid },
    } = form;

    const onSave = () => {
        if (!isValid) return;

        useCreateActivityTypeMutation.mutate(form.getValues(), {
            onSuccess: () => {
                navigate(returnUrlOrdenTrabajoParametrosPage);
                toast.success("Tipo Actividad registrada correctamente")
            },
            onError: (error: any) => {
                console.error('Error al crear el Tipo Actividad:', error);
                if (error.response?.data?.message) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error('Error al crear el Tipo Actividad');
                }
            }
        });
    };

    return (
        <>
            <SingleTableBoxScene
                title={"Crear Tipo de Actividad"}
                textRedirect={"Atras"}
                iconRedirect={<ArrowBack />}
                urlRedirect={`${returnUrlOrdenTrabajoParametrosPage}`}
                visibleReport={true}
            >

                <SingleFormBoxScene
                    titlePage={""}
                    onCancel={() => {
                        navigate(returnUrlOrdenTrabajoParametrosPage);
                    }}
                    containerMaxWidth={"sm"}
                    py={6}
                    onSave={handleSubmit(onSave)}
                >

                    <CustomTextField
                        label="Nombre Tipo de Actividad"
                        name="nameActivityType"
                        control={control}
                        defaultValue={form.getValues().nameActivityType || ''}
                        error={errors.nameActivityType}
                        helperText={errors.nameActivityType?.message ?? ''}
                        size={gridSizeMdLg12}
                    />

                </SingleFormBoxScene>
            </SingleTableBoxScene>
        </>
    )
}